import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.BatchPaymentSection', {
    bankAccountNumberLabel: 'Bank account number',
    bankAccountNumberPlaceholder: 'Enter Bank account number',
    sortCodeLabel: 'Sort code',
    sortCodePlaceholder: 'Enter sort code',
});
